import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const Register = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(formData);
      toast.success('Compte créé avec succès !');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de l\'inscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex items-center justify-center px-8 py-12">
        <div className="w-full max-w-md">
          <img src="/logo.jpg" alt="PDE Logo" className="h-16 mx-auto mb-8" />
          <h2 className="text-3xl font-heading font-bold text-[#0A2540] mb-2 text-center">Créer un compte</h2>
          <p className="text-[#64748B] text-center mb-8">Commencez à gérer vos analyses TICFE</p>
          
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="register-form">
            <div>
              <label className="block text-sm font-medium text-[#334155] mb-2">Nom complet</label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="w-full px-4 py-3 border border-[#CBD5E1] rounded-lg focus:ring-2 focus:ring-[#0A2540] focus:border-[#0A2540] transition-all"
                data-testid="register-name-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#334155] mb-2">Email</label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-4 py-3 border border-[#CBD5E1] rounded-lg focus:ring-2 focus:ring-[#0A2540] focus:border-[#0A2540] transition-all"
                data-testid="register-email-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#334155] mb-2">Mot de passe</label>
              <input
                type="password"
                required
                minLength={6}
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                className="w-full px-4 py-3 border border-[#CBD5E1] rounded-lg focus:ring-2 focus:ring-[#0A2540] focus:border-[#0A2540] transition-all"
                data-testid="register-password-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#0A2540] hover:bg-[#0D3A5F] text-white font-medium py-3 px-6 rounded-lg transition-colors disabled:opacity-50"
              data-testid="register-submit-button"
            >
              {loading ? 'Création...' : 'Créer mon compte'}
            </button>
          </form>
          
          <p className="mt-6 text-center text-sm text-[#64748B]">
            Déjà un compte ?{' '}
            <Link to="/login" className="text-[#397DFF] font-medium hover:underline">
              Se connecter
            </Link>
          </p>
        </div>
      </div>
      <div className="hidden lg:block flex-1 bg-cover bg-center relative" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1767789082653-e30a047584fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZmFjdG9yeSUyMGVuZXJneXxlbnwwfHx8fDE3Njg3Njk1NzJ8MA&ixlib=rb-4.1.0&q=85)'}}>
        <div className="absolute inset-0 bg-black/60" />
      </div>
    </div>
  );
};

export default Register;
